export default "__VITE_ASSET__15780446__"